// extracted by mini-css-extract-plugin
export var address = "components-account-__PurchasePanel-module___address";
export var billingAmount = "components-account-__PurchasePanel-module___billingAmount";
export var billingCard = "components-account-__PurchasePanel-module___billingCard";
export var ccIcon = "components-account-__PurchasePanel-module___ccIcon";
export var container = "components-account-__PurchasePanel-module___container";
export var item = "components-account-__PurchasePanel-module___item";
export var subheader = "components-account-__PurchasePanel-module___subheader";